import { MutationTree } from 'vuex';
import { State } from '@/manager/business/store/state';
import InternalBusiness from '@/manager/business/models/internal-business.model';

export interface Mutations {
    setInternalBusinessList: {list: InternalBusiness[]};
}

export const mutations: MutationTree<State> = {
    setInternalBusinessList: (state, payload) => {
        state.internalBusinessList = payload;
    },
    setProviderList: (state, payload) => {
        state.providerList = payload;
    },
};
